export function groupBy(array: any[], size: number): any[] {
  const grouped = [];
  for (let i = 0; i < array.length; i += size) {
    grouped.push(array.slice(i, i + size));
  }
  return grouped;
}

export function buildWhatsAppUrl(telefone: string, mensagem: string): string {
  const numeroFormatado = telefone.replace(/[^0-9]/g, "");
  const mensagemCodificada = encodeURIComponent(mensagem);
  return `https://wa.me/55${numeroFormatado}?text=${mensagemCodificada}`;
}

export function groupByImoveis(array: any[], size: number): any[] {
    const grouped = [];
    for (let i = 0; i < array.length; i += size) {
      grouped.push(array.slice(i, i + size));
    }
    return grouped;
  }